import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

const ICalendarSyncStrings = {
  instructions: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.i_cal.instructions"
      defaultMessage="Copy and paste the export URL provided by your external calendar. URL must be in iCalendar (iCal or ics) format."
    />
  ),
  nameInputLabel: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.i_cal.input_title_cal_name"
      defaultMessage="Calendar name"
    />
  ),
  urlInputLabel: (
    <FormattedMessage
      id="calendar.sync_flow.dialog.i_cal.input_title_cal_addr"
      defaultMessage="Calendar address (URL)"
    />
  ),
  placeholders: defineMessages({
    nameInput: {
      id: 'calendar.sync_flow.dialog.i_cal.input_placeholder_cal_name',
      defaultMessage: 'Airbnb calendar'
    },
    urlInput: {
      id: 'calendar.sync_flow.dialog.i_cal.input_placeholder_cal_addr',
      defaultMessage: 'Link'
    }
  })
};

export default ICalendarSyncStrings;
